"use client";

import React, { useState, useEffect } from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useTranslations } from "next-intl";

import { useAnalytics } from "@/components/analytics/use-analytics";

const ThemeToggle: React.FC = () => {
  const t = useTranslations("themeToggle");
  const { resolvedTheme, setTheme } = useTheme();
  const { trackEvent } = useAnalytics();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleToggle = () => {
    if (!mounted) return;
    const newTheme = resolvedTheme === "dark" ? "light" : "dark";
    trackEvent("theme_changed", {
      from_theme: resolvedTheme,
      to_theme: newTheme,
    });
    setTheme(newTheme);
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      disabled={!mounted}
      className="flex min-h-11 min-w-11 items-center justify-center text-foreground/80 transition-colors hover:text-primary lg:min-h-0 lg:min-w-0"
      aria-label={t("label")}
    >
      {mounted && resolvedTheme === "dark" ? (
        <Sun className="h-4 w-4" />
      ) : (
        <Moon className="h-4 w-4" />
      )}
    </button>
  );
};

export default ThemeToggle;
